import React, { useState, useRef, useCallback } from 'react';

import DeckGL, {GeoJsonLayer, HexagonLayer, ScatterplotLayer, TileLayer, BitmapLayer} from 'deck.gl';
import {COORDINATE_SYSTEM} from '@deck.gl/core';
import {loadImage} from '@loaders.gl/images';
import Tooltip from './Tooltip'

import * as d3 from 'd3';

const COORDINATE_ORIGIN = [19, 47];

const COLOR_RANGE = [
  [150, 200, 235],
  [73, 227, 206],
  [216, 254, 181],
  [254, 237, 177],
  [254, 173, 84],
  [209, 55, 78]
];

export default ({data, layerOptions, viewState, onViewStateChange, filterFn, size}) => {

  const { baseMap, scatterplot, hexagon, tiles } = layerOptions;

  const deckgl = useRef(null);
  if (viewState != null)
  delete viewState["default-view"]
  const [mapViewState, setMapViewState] = useState(viewState);
  const[hoverData, setHoverData] = useState({x: 0, y: 0, balNum: 0, obj: null, type: null});

  const changeState = useCallback(({viewState}) => {
    onViewStateChange(viewState)
    setMapViewState(viewState);
  }, [])

  const OnHover = (d) => {
    //return
    if(d != null) {
      setHoverData({x: d.x, y: d.y, obj: d.object, type: d.layer.id});
    } else {
      setHoverData({x: null, y: null, obj: null, type: null});
    }
  } 
  const getColorScatterplotLayer = (d) => {
    if(d.properties.inHun === false) return [250, 0, 0, 0];
    return filterFn(d) ? [250, 0, 0, 120] : [250, 0, 0, 0];
  }

  const getColorHexagonLayer = (d) => {
    if(d.properties.inHun === false) return 0;
    return filterFn(d) ? 1 : 0;
  }

  // const scale = d3.scaleLinear()
  //   .domain([6, 13])
  //   .range([0, 255]);

  return (
    <React.Fragment>
      <Tooltip 
        hoverData={hoverData} 
        deckGL={deckgl} 
        filterFn={filterFn} />
      <div className="map">
      <DeckGL
        width={size}
        height={size}
        ref={deckgl}
        className="mapCanvas"
        controller={true}
        initialViewState={mapViewState}
        onViewStateChange={onViewStateChange} 
        useDevicePixels={false}
        //onResize={onResize}
        >
        {baseMap.visible && <GeoJsonLayer
          id="baseMap"
          data={'megye.json'}
          visible={true}
          stroked={true}
          filled={true}
          opacity={1}
          getLineWidth={1}
          getLineColor={[60, 60, 60, 255]}
          getFillColor={[0, 0, 0, 255]}
          lineWidthUnits={'pixels'}
          {...baseMap}
        /> }
        <GeoJsonLayer
          id="baseMapRoads"
          data={'roads.geojson'}
          visible={true}
          stroked={true}
          filled={true}
          opacity={1}
          getLineWidth={1}
          getLineColor={[60, 60, 60, 160]}
          getFillColor={[0, 0, 0, 0]}
          lineWidthUnits={'pixels'}
          {...baseMap}
        />
        {/* {tiles.visible && <TileLayer
          id="mapLayer"
          visible={false}
          getTileData={({x, y, z}) => loadImage(`https://cartodb-basemaps-a.global.ssl.fastly.net/dark_all/${z}/${x}/${y}.png`)}
          renderSubLayers={props => {
            const {
              bbox: {west, south, east, north}
            } = props.tile;

            return new BitmapLayer(props, {
              data: null,
              image: props.data,
              bounds: [west, south, east, north]
            });
          }}
          {...tiles}
        /> } */}
        <ScatterplotLayer
          id="scatterplot"
          data={data}
          //dataComparator={d => data.length === 0}
          pickable={true}
          visible={true}
          coordinateSystem={COORDINATE_SYSTEM.LNGLAT_OFFSETS}
          coordinateOrigin={COORDINATE_ORIGIN}
          // getPollygonOffset={({layerIndex}) => [0, -layerIndex * 200]}
          stroked={false}
          filled={true}
          radiusScale={10}
          radiusMinPixels={1}
          radiusMaxPixels={8}
          getPosition={d => d.geometry.coordinates}
          getRadius={10}
          //getColor={d => filterFn(d) ? [250, 0, 0, 120] : [250, 0, 0, 0]}
          getFillColor={d => getColorScatterplotLayer(d)}
          updateTriggers={{
            getFillColor: [filterFn]
          }}
          // transitions={{
          //   getColor: 500
          // }}
          
          onHover={(info) => {
            OnHover(info);
          }}
          {...scatterplot}
        />

        <HexagonLayer
          id="hexagon"
          coordinateSystem={COORDINATE_SYSTEM.LNGLAT_OFFSETS}
          coordinateOrigin={COORDINATE_ORIGIN}
          visible={false}
          extruded={true}
          data={data}
          //dataComparator={() => data.length == 0}
          getPosition={d => d.geometry.coordinates}
          elevationScale={100}
          radius={1000}
          elevationDomain={[0.01, 1078]}
          //colorDomain={[0.01, 1060]}
          upperPercentile={100}
          coverage={1}
          pickable={true}
          colorRange={COLOR_RANGE}
          //getElevationValue={d =>d.length }
          getColorWeight={point => filterFn(point) ? 1 : 0}
          colorAggregation="SUM"
          getElevationWeight={point => getColorHexagonLayer(point)}
          elevationAggregation="SUM"
          updateTriggers={{
            getElevationWeight: [filterFn],
            getColorWeight: [filterFn]
          }}
          
          onHover={(info) => {
            OnHover(info);
        }}

          {...hexagon}
          />
      </DeckGL>
    </div>

    </React.Fragment>
  );
}
